import axios from 'axios'
import store from '@/store'

export const setAuthorization = (newToken) => {
	axios.defaults.headers.common['Authorization'] = 'Bearer ' + newToken
}

export function abortController() {
	const controller = new AbortController()
	const signal = controller.signal

	return { controller, signal }
}

const baseUrl = () => {
	if (process.env.NODE_ENV === 'development') {
		let lsBaseUrl = localStorage.getItem('baseUrl')
		// store.subscribe((mutation, state) => {
		// 	console.log('AXIOSAXIOS', state.baseUrl)
		// 	lsBaseUrl = state.baseUrl
		// })
		if (lsBaseUrl) {
			return lsBaseUrl
		}

		return 'https://api2-dev.jfx.co.id'
	}
	return 'https://api2-v2.jfx.co.id'
}

const api = axios.create({
	baseURL: baseUrl(),
	// headers: {'Authorization': 'Bearer ' + token.tokenValue},
})

// --- Cancellable Request Factory ---
export const createCancellableRequest = () => {
	const controller = new AbortController()

	const request = async (config) => {
		try {
			const response = await api({
				...config,
				signal: controller.signal,
			})
			return response
		} catch (error) {
			throw error
		}
	}

	return {
		request,
		cancel: () => controller.abort(),
	}
}

export default api